import { isUndNullEmpNew } from '../../helpers/UtilsHelper';

export class RateClass {
    constructor(
        id = '',
        rate = 0.00,
        register = new Date()?.toISOString(),
        userId = '',
    ) {
        this.id = id;
        this.rate = rate;
        this.register = register;
        this.userId = userId;
    };

    static getClassName = () => {
        return 'Rate - class';
    }

    static getClass = (obj = Object) => {
        if (!isUndNullEmpNew({ data: obj, subMethod: this.getClassName() })?.result) {
            return new RateClass(
                obj?.id,
                obj?.rate,
                obj?.register,
                obj?.userId,
            );
        }

        return new RateClass();
    }
}